import { Alternative } from './Alternative';
import { MatrixRow } from './MatrixRow';

/**
 Class representing a question
 */
export class Question {
    /**
     * Create a question.
     * @param {Object} question - The question
     * @param {Number} question.questionId - The question id.
     * @param {string} question.text - The question text.
     * @param {boolean} question.hasHtml - true if the question contains safe html, and should be rendered as html
     * @param {('Open'|'MultipleChoice'|'YesNo'|'Matrix')} question.type - The type of question.
     * @param {Number} question.maxAlternativesToSelect - Max number of alternatives that can be selected. 1 => radio buttons.
     * @param {Number} question.orderNo - Determines sequence for the questions, starting from the lowest.
     * @param {boolean} question.isUiSelected - flag to set if question should be selected in ui
     * @param {Array<Alternative>} question.alternatives - The alternatives (used for question types 'MultipleChoice' and 'Matrix').
     * @param {Array<MatrixRow>} question.matrixRows - The matrix rows (used for question type 'Matrix').
     */
    constructor(question) {
        this.questionId = question.questionId;
        this.text = question.text;
        this.hasHtml = question.hasHtml;
        this.type = question.type;
        this.maxAlternativesToSelect = question.maxAlternativesToSelect ? question.maxAlternativesToSelect : 0;
        this.orderNo = question.orderNo;
        this.isUiSelected = false;
        this.alternatives = question.alternatives ? question.alternatives.map(a => new Alternative(a)) : [];
        this.matrixRows = question.matrixRows ? question.matrixRows.map(r => new MatrixRow(r)) : [];
    }

    /**
     * @returns {boolean} true if the type is 'MultipleChoice' and more than one alternative can be selected.
     */
    isMultipleResponse() {
        return this.type === 'MultipleChoice' && this.maxAlternativesToSelect !== 1;
    }

    /**
     * @returns {Number} The number of lines in the text (counting line feed '\n' + 1). An empty text will return 1.
     */
    getNumberOfLines() {
        return (this.text.match(/\n/g) || []).length + 1;
    }
}
